import React from "react";
import PatioManagerDocaListPageContainer from "./PatioManagerDocaListPageContainer";
export class PatioManagerDocaListPage extends React.Component {
  render() {
    return <PatioManagerDocaListPageContainer {...this.props} />;
  }
}
